<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div>
        <img class="center-svg" src="assets/svg/money-icon.svg" alt="" />
      </div>
      <div>
        <h4 class="text-semibold">
          {{data.mode === 'edit' ? "Modificar informaci&oacute;n presupuesto" :
          "Nuevo presupuesto"}}
        </h4>
        <h6 class="color-gray" style="font-weight: 400">
          {{data.mode === 'edit' ? "Completa los datos que necesitas modificar
          del presupuesto" : "Completa los datos para registrar un nuevo
          presupuesto"}}
        </h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img
              (click)="closeMdl();"
              class="close-button"
              src="assets/svg/close-icon.svg"
              alt=""
            />
          </div>
        </h3>
      </div>
    </div>
    <div class="mdl-body">
      <h5 class="text-semibold mt-4">Información del presupuesto</h5>
      <form #BudgetForm="ngForm" (ngSubmit)="$event.preventDefault()">
      <div
        class="d-grid prospect-form"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
        <div>
         <div class="mt-3">
          <label class="login-label" for="nombre_presupuesto">
            <span class="required-asterisk"
                  *ngIf="!request.nombre_presupuesto || request.nombre_presupuesto.trim() === ''">*</span>
            Nombre del presupuesto:
          </label>
          <input
            class="crm-input"
            type="text"
            id="nombre_presupuesto"
            name="nombre_presupuesto"
            [(ngModel)]="request.nombre_presupuesto"
            placeholder="Escriba el nombre del presupuesto"
            required
            #nombrePresupuestoCtrl="ngModel"
          />
          <div class="error-text" *ngIf="nombrePresupuestoCtrl.invalid && nombrePresupuestoCtrl.touched">
            <small *ngIf="nombrePresupuestoCtrl.errors?.['required']">
              El nombre del presupuesto es obligatorio
            </small>
          </div>
        </div>

          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk"
                    *ngIf="!request.oportunidad_id || request.oportunidad_id === ''">*</span>
              Nombre de la oportunidad:
            </label>

            <ng-select
              class="crm-ng-select input-bordered"
              [items]="oportunidades"
              bindLabel="nombre"
              bindValue="oportunidad_id"
              placeholder="Seleccionar oportunidad..."
              name="oportunidad_id"
              [(ngModel)]="request.oportunidad_id"
              required
              #oportunidadCtrl="ngModel"
              [searchable]="true"
              [clearable]="false"
              (change)="onOportunidadSeleccionada(request.oportunidad_id)"
            >
            </ng-select>

            <div class="error-text" *ngIf="oportunidadCtrl.invalid && oportunidadCtrl.touched">
              <small *ngIf="oportunidadCtrl.errors?.['required']">
                La oportunidad es obligatoria
              </small>
            </div>
          </div>


          <div class="mt-3">
          <label for="estado" class="login-label">
            <span class="required-asterisk"
                  *ngIf="!request.id_estado || request.id_estado.trim() === ''">*</span>
            Estado:
          </label>
          <select
            class="crm-input"
            id="estado"
            name="id_estado"
            [(ngModel)]="request.id_estado"
            required
            #estadoCtrl="ngModel"
          >
            <option value="" disabled>Seleccione el estado del presupuesto</option>
            @for (status of statuses; track status.id_estado) {
              <option [value]="status.id_estado">{{ status.nombre }}</option>
            }
          </select>

          <div class="error-text" *ngIf="estadoCtrl.invalid && estadoCtrl.touched">
            <small *ngIf="estadoCtrl.errors?.['required']">
              El estado es obligatorio
            </small>
          </div>
        </div>

          <div class="mt-3">
            <label class="login-label" for="descripcion">Descripción :</label>
            <input
              class="crm-input"
              type="text"
              name="descripcion"
              id="descripcion"
              [(ngModel)]="request.descripcion"
              placeholder="Descripcion del presupuesto (opcional)"
            />
          </div>
        </div>

        <div>
          <div class="mt-3">
            <label class="login-label" for="fecha_caducidad">
              <span class="required-asterisk"
                    *ngIf="!request.fecha_caducidad || request.fecha_caducidad === ''">*</span>
              Fecha de caducidad:
            </label>
            <input
              class="crm-input"
              type="date"
              name="fecha_caducidad"
              id="fecha_caducidad"
              [(ngModel)]="request.fecha_caducidad"
              [min]="minDate"
              placeholder="Selecciona la fecha de caducidad"
              required
              #fechaCadCtrl="ngModel"
            />
            <div class="error-text" *ngIf="fechaCadCtrl.invalid && fechaCadCtrl.touched">
              <small *ngIf="fechaCadCtrl.errors?.['required']">
                La fecha de caducidad es obligatoria
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Cuenta asociada:</label>
            <input
              class="crm-input"
              name="cuentaSeleccionanada"
              type="text"
              [value]="nombreCuentaSeleccionada"
              placeholder="Selecciona una oportunidad para mostrar la cuenta"
              disabled
            />
          </div>

          <div class="mt-3">
            <label for="divisa_presupuesto" class="login-label"
              >Divisa de presupuesto:</label
            >
            <select
              class="crm-input"
              id="divisa_presupuesto"
              name="divisa_presupuesto"
              [(ngModel)]="request.divisa_presupuesto"
            >
              <option value="" disabled selected>Seleccione</option>
              <option value="CLP">CLP</option>
              <option value="USD">USD</option>
            </select>
          </div>
        </div>
      </div>

      <h5 class="text-semibold mt-4">Totales</h5>
      <div
        class="d-grid prospect-form"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
      
        <div class="mt-3">
          <label class="login-label" for="envio">Envio :</label>
          <input
            class="crm-input"
            type="number"
            name="envio"
            id="envio"
            [(ngModel)]="request.envio"
          />
        </div>
      </div>

      <h5 class="text-semibold mt-4">Preparado por</h5>
      <div
        class="d-grid prospect-form"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
        <div>
         <div class="mt-3">
          <label class="login-label">
            <span class="required-asterisk"
                  *ngIf="!request.contacto_id || request.contacto_id === ''">*</span>
            Nombre del contacto:
          </label>

          <ng-select
            class="crm-ng-select input-bordered"
            [items]="contactosFiltrados"
            bindLabel="nombre"
            bindValue="contacto_id"
            placeholder="Seleccionar contacto..."
            name="contacto_id"
            [(ngModel)]="request.contacto_id"
            required
            #contactoCtrl="ngModel"
            [searchable]="true"
            [clearable]="false"
            (change)="onchangeContactoSeleccionado($event)"
          >
          </ng-select>

          <div class="error-text" *ngIf="contactoCtrl.invalid && contactoCtrl.touched">
            <small *ngIf="contactoCtrl.errors?.['required']">
              El contacto es obligatorio
            </small>
          </div>
        </div>

          <div class="mt-3">
            <label class="login-label" for="correo">Correo:</label>
            <input
              class="crm-input"
              type="text"
              name="correo"
              id="correo"
              [(ngModel)]="request.correo"
              readonly
            />
          </div>
        </div>
        <div>
          <div class="mt-3">
            <label class="login-label" for="telefono">Telefono:</label>
            <input
              class="crm-input"
              type="text"
              name="telefono"
              id="telefono"
              [(ngModel)]="request.telefono"
              readonly
            />
          </div>
        </div>
      </div>

      <div
        class="d-grid prospect-form"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
        <div>
          <h5 class="text-semibold mt-4">Dirección de facturación</h5>
          <div class="mt-3">
            <label class="login-label" for="nombre_fact"
              >Nombre de facturación:</label
            >
            <input
              class="crm-input"
              type="text"
              id="nombre_fact"
              name="nombre_fact"
              [(ngModel)]="request.nombre_fact"
              placeholder="Ingrese el nombre de facturación"
            />
          </div>
          <div class="mt-3">
            <label class="login-label" for="calle_fact">Calle:</label>
            <input
              class="crm-input"
              type="text"
              id="calle_fact"
              name="calle_fact"
              [(ngModel)]="request.calle_fact"
              placeholder="Av. Libertador 1234"
            />
          </div>
          <div class="mt-3">
            <label class="login-label" for="region_fact">Región</label>
            <select
              class="crm-input"
              id="region_fact"
              name="region_fact"
              [(ngModel)]="request.region_fact"
              (change)="getComunasFact(request.region_fact)"
            >
              @for(item of regiones; track item.NombreRegion){
              <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
              }
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label" for="ciudad_fact">Comuna</label>
            <select
              class="crm-input"
              name="ciudad_fact"
              id="ciudad_fact"
              [(ngModel)]="request.ciudad_fact"
            >
              @for (comuna of comunasFact; track comuna) {
              <option [value]="comuna">{{ comuna }}</option>
              }
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label" for="pais_fact">País</label>
            <input
              class="crm-input"
              name="pais_fact"
              type="text"
              id="pais_fact"
              [(ngModel)]="request.pais_fact"
              disabled
            />
          </div>
        </div>
        <div>
          <h5 class="text-semibold mt-4">Dirección de envío</h5>
          <div class="mt-3">
            <label class="login-label" for="nombre_env"
              >Nombre de envío::</label
            >
            <input
              class="crm-input"
              type="text"
              name="nombre_env"
              id="nombre_env"
              [(ngModel)]="request.nombre_env"
              placeholder="Ingrese el nombre de envío"
            />
          </div>
          <div class="mt-3">
            <label class="login-label" for="calle_env">Calle:</label>
            <input
              class="crm-input"
              name="calle_env"
              type="text"
              id="calle_env"
              [(ngModel)]="request.calle_env"
              placeholder="Av. Libertador 1234"
            />
          </div>
          <div class="mt-3">
            <label class="login-label" for="region_env">Región</label>
            <select
              class="crm-input"
              id="region_env"
              name="region_env"
              [(ngModel)]="request.region_env"
              (change)="getComunasEnv(request.region_env)"
            >
              @for(item of regiones; track item.NombreRegion){
              <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
              }
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label" for="ciudad_env">Comuna</label>
            <select
              class="crm-input"
              id="ciudad_env"
              name="ciudad_env"
              [(ngModel)]="request.ciudad_env"
            >
              @for (comuna of comunasEnv; track comuna) {
              <option [value]="comuna">{{ comuna }}</option>
              }
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label" for="pais_env">País</label>
            <input
              class="crm-input"
              type="text"
              name="pais_env"
              id="pais_env"
              [(ngModel)]="request.pais_env"
              disabled
            />
          </div>
        </div>
      </div>

      <hr class="mt-5 mb-5" />
      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button
        type="button"
          (click)="closeMdl();"
          class="btn btn-primary-outline text-center"
        >
          Cancelar
        </button>
        @if(data.mode === 'edit'){
        <button type="button" class="btn btn-primary text-center" (click)="updateBudget();" [disabled]="!BudgetForm.valid">
          Modificar Presupuesto
        </button>
        }@else{
        <button type="button" class="btn btn-primary text-center" (click)="createBudget();" [disabled]="!BudgetForm.valid">
          A&#241;adir nuevo Presupuesto
        </button>
        }
      </div>
      </form>
    </div>
  </div>
</div>
